import moment from 'moment-timezone';

export function formatPeriodDatetime(
  isoString: string,
  timezone?: string,
  // 12-hour clock when true; 24-hour otherwise (incl. 'auto', preserving the
  // pre-preference default for this moment-formatted display).
  hour12?: boolean
): string {
  const m = timezone ? moment.parseZone(isoString).tz(timezone) : moment.parseZone(isoString);
  const abbr = m.format('z');
  const timeToken = hour12 ? 'h:mm A' : 'HH:mm';
  const datetime = m.format(`ddd, MMM D, YYYY [at] ${timeToken}`);
  return `${datetime} (${abbr})`;
}

export function calculateDuration(openIso: string, closeIso: string): string {
  const openMs = moment.parseZone(openIso).valueOf();
  const closeMs = moment.parseZone(closeIso).valueOf();
  const diffMs = closeMs - openMs;

  if (diffMs <= 0) return '0m';

  const totalMinutes = Math.floor(diffMs / 60_000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${minutes}m`;
  }
}
